<ng-container *ngIf="isTranslationLoaded$ | async; else loading">
  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
  <app-cookie-consent></app-cookie-consent>
</ng-container>

<ng-template #loading>
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>